// extracted by mini-css-extract-plugin
module.exports = {"cluster-owner-label":"JobClusterCard_cluster-owner-label_33uLy"};